"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Collection = _interopRequireDefault(require("../Collection.js"));

var _EventType = _interopRequireDefault(require("../render/EventType.js"));

var _Feature = _interopRequireDefault(require("../Feature.js"));

var _Fill = _interopRequireDefault(require("../style/Fill.js"));

var _GeometryLayout = _interopRequireDefault(require("../geom/GeometryLayout.js"));

var _LineString = _interopRequireDefault(require("../geom/LineString.js"));

var _Point = _interopRequireDefault(require("../geom/Point.js"));

var _Stroke = _interopRequireDefault(require("../style/Stroke.js"));

var _Style = _interopRequireDefault(require("../style/Style.js"));

var _Text = _interopRequireDefault(require("../style/Text.js"));

var _Vector = _interopRequireDefault(require("./Vector.js"));

var _Vector2 = _interopRequireDefault(require("../source/Vector.js"));

var _extent = require("../extent.js");

var _obj = require("../obj.js");

var _math = require("../math.js");

var _coordinate = require("../coordinate.js");

var _proj = require("../proj.js");

var _render = require("../render.js");

var _geodesic = require("../geom/flat/geodesic.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/layer/Graticule
 */


/**
 * @type {Stroke}
 * @private
 * @const
 */
var DEFAULT_STROKE_STYLE = new _Stroke["default"]({
  color: 'rgba(0,0,0,0.2)'
});
/**
 * @type {Array<number>}
 * @private
 */

var INTERVALS = [90, 45, 30, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.01, 0.005, 0.002, 0.001];
/**
 * @typedef {Object} GraticuleLabelDataType
 * @property {Point} geom Geometry.
 * @property {string} text Text.
 */

/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [maxLines=100] The maximum number of meridians and
 * parallels from the center of the map. The default value of 100 means that at
 * most 200 meridians and 200 parallels will be displayed. The default value is
 * appropriate for conformal projections like Spherical Mercator. If you
 * increase the value, more lines will be drawn and the drawing performance will
 * decrease.
 * @property {Stroke} [strokeStyle] The
 * stroke style to use for drawing the graticule. If not provided, the following stroke will be used:
 * ```js
 * new Stroke({
 *   color: 'rgba(0, 0, 0, 0.2)' // a not fully opaque black
 * });
 * ```
 * @property {number} [targetSize=100] The target size of the graticule cells,
 * in pixels.
 * @property {boolean} [showLabels=false] Render a label with the respective
 * latitude/longitude for each graticule line.
 * @property {function(number):string} [lonLabelFormatter] Label formatter for
 * longitudes. This function is called with the longitude as argument, and
 * should return a formatted string representing the longitude. By default,
 * labels are formatted as degrees, minutes, seconds and hemisphere.
 * @property {function(number):string} [latLabelFormatter] Label formatter for
 * latitudes. This function is called with the latitude as argument, and
 * should return a formatted string representing the latitude. By default,
 * labels are formatted as degrees, minutes, seconds and hemisphere.
 * @property {number} [lonLabelPosition=0] Longitude label position in fractions
 * (0..1) of view extent. 0 means at the bottom of the viewport, 1 means at the
 * top.
 * @property {number} [latLabelPosition=1] Latitude label position in fractions
 * (0..1) of view extent. 0 means at the left of the viewport, 1 means at the
 * right.
 * @property {Text} [lonLabelStyle] Longitude label text
 * style. If not provided, the following style will be used:
 * ```js
 * new Text({
 *   font: '12px Calibri,sans-serif',
 *   textBaseline: 'bottom',
 *   fill: new Fill({
 *     color: 'rgba(0,0,0,1)'
 *   }),
 *   stroke: new Stroke({
 *     color: 'rgba(255,255,255,1)',
 *     width: 3
 *   })
 * });
 * ```
 * Note that the default's `textBaseline` configuration will not work well for
 * `lonLabelPosition` configurations that position labels close to the top of
 * the viewport.
 * @property {Text} [latLabelStyle] Latitude label text style.
 * If not provided, the following style will be used:
 * ```js
 * new Text({
 *   font: '12px Calibri,sans-serif',
 *   textAlign: 'end',
 *   fill: new Fill({
 *     color: 'rgba(0,0,0,1)'
 *   }),
 *   stroke: Stroke({
 *     color: 'rgba(255,255,255,1)',
 *     width: 3
 *   })
 * });
 * ```
 * Note that the default's `textAlign` configuration will not work well for
 * `latLabelPosition` configurations that position labels close to the left of
 * the viewport.
 * @property {Array<number>} [intervals=[90, 45, 30, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.01, 0.005, 0.002, 0.001]]
 * Intervals (in degrees) for the graticule. Example to limit graticules to 30 and 10 degrees intervals:
 * ```js
 * [30, 10]
 * ```
 * @property {boolean} [wrapX=true] Whether to repeat the graticule horizontally.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */

/**
 * @classdesc
 * Layer that renders a grid for a coordinate system (currently only EPSG:4326 is supported).
 * Note that the view projection must define both extent and worldExtent.
 *
 * @fires import("../render/Event.js").RenderEvent
 * @extends {VectorLayer<import("../source/Vector.js").default>}
 * @api
 */

var Graticule =
/** @class */
function (_super) {
  __extends(Graticule, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function Graticule(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    var baseOptions = (0, _obj.assign)({
      updateWhileAnimating: true,
      updateWhileInteracting: true,
      renderBuffer: 0
    }, options);
    delete baseOptions.maxLines;
    delete baseOptions.strokeStyle;
    delete baseOptions.targetSize;
    delete baseOptions.showLabels;
    delete baseOptions.lonLabelFormatter;
    delete baseOptions.latLabelFormatter;
    delete baseOptions.lonLabelPosition;
    delete baseOptions.latLabelPosition;
    delete baseOptions.lonLabelStyle;
    delete baseOptions.latLabelStyle;
    delete baseOptions.intervals;
    _this = _super.call(this, baseOptions) || this;
    /**
     * @type {import("../proj/Projection.js").default}
     */

    _this.projection_ = null;
    /**
     * @type {number}
     * @private
     */

    _this.maxLat_ = Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.maxLon_ = Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.minLat_ = -Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.minLon_ = -Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.maxX_ = Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.maxY_ = Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.minX_ = -Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.minY_ = -Infinity;
    /**
     * @type {number}
     * @private
     */

    _this.targetSize_ = options.targetSize !== undefined ? options.targetSize : 100;
    /**
     * @type {number}
     * @private
     */

    _this.maxLines_ = options.maxLines !== undefined ? options.maxLines : 100;
    /**
     * @type {Array<LineString>}
     * @private
     */

    _this.meridians_ = [];
    /**
     * @type {Array<LineString>}
     * @private
     */

    _this.parallels_ = [];
    /**
     * @type {Stroke}
     * @private
     */

    _this.strokeStyle_ = options.strokeStyle !== undefined ? options.strokeStyle : DEFAULT_STROKE_STYLE;
    /**
     * @type {import("../proj.js").TransformFunction|undefined}
     * @private
     */

    _this.fromLonLatTransform_ = undefined;
    /**
     * @type {import("../proj.js").TransformFunction|undefined}
     * @private
     */

    _this.toLonLatTransform_ = undefined;
    /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.projectionCenterLonLat_ = null;
    /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.bottomLeft_ = null;
    /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.bottomRight_ = null;
    /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.topLeft_ = null;
    /**
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.topRight_ = null;
    /**
     * @type {Array<GraticuleLabelDataType>}
     * @private
     */

    _this.meridiansLabels_ = null;
    /**
     * @type {Array<GraticuleLabelDataType>}
     * @private
     */

    _this.parallelsLabels_ = null;

    if (options.showLabels) {
      /**
       * @type {null|function(number):string}
       * @private
       */
      _this.lonLabelFormatter_ = options.lonLabelFormatter == undefined ? _coordinate.degreesToStringHDMS.bind(_this, 'EW') : options.lonLabelFormatter;
      /**
       * @type {function(number):string}
       * @private
       */

      _this.latLabelFormatter_ = options.latLabelFormatter == undefined ? _coordinate.degreesToStringHDMS.bind(_this, 'NS') : options.latLabelFormatter;
      /**
       * Longitude label position in fractions (0..1) of view extent. 0 means
       * bottom, 1 means top.
       * @type {number}
       * @private
       */

      _this.lonLabelPosition_ = options.lonLabelPosition == undefined ? 0 : options.lonLabelPosition;
      /**
       * Latitude Label position in fractions (0..1) of view extent. 0 means left, 1
       * means right.
       * @type {number}
       * @private
       */

      _this.latLabelPosition_ = options.latLabelPosition == undefined ? 1 : options.latLabelPosition;
      /**
       * @type {Style}
       * @private
       */

      _this.lonLabelStyleBase_ = new _Style["default"]({
        text: options.lonLabelStyle !== undefined ? options.lonLabelStyle.clone() : new _Text["default"]({
          font: '12px Calibri,sans-serif',
          textBaseline: 'bottom',
          fill: new _Fill["default"]({
            color: 'rgba(0,0,0,1)'
          }),
          stroke: new _Stroke["default"]({
            color: 'rgba(255,255,255,1)',
            width: 3
          })
        })
      });
      /**
       * @private
       * @param {import("../Feature").default} feature Feature
       * @return {Style} style
       */

      _this.lonLabelStyle_ = function (feature) {
        var label = feature.get('graticule_label');
        this.lonLabelStyleBase_.getText().setText(label);
        return this.lonLabelStyleBase_;
      }.bind(_this);
      /**
       * @type {Style}
       * @private
       */


      _this.latLabelStyleBase_ = new _Style["default"]({
        text: options.latLabelStyle !== undefined ? options.latLabelStyle.clone() : new _Text["default"]({
          font: '12px Calibri,sans-serif',
          textAlign: 'right',
          fill: new _Fill["default"]({
            color: 'rgba(0,0,0,1)'
          }),
          stroke: new _Stroke["default"]({
            color: 'rgba(255,255,255,1)',
            width: 3
          })
        })
      });
      /**
       * @private
       * @param {import("../Feature").default} feature Feature
       * @return {Style} style
       */

      _this.latLabelStyle_ = function (feature) {
        var label = feature.get('graticule_label');
        this.latLabelStyleBase_.getText().setText(label);
        return this.latLabelStyleBase_;
      }.bind(_this);

      _this.meridiansLabels_ = [];
      _this.parallelsLabels_ = [];

      _this.addEventListener(_EventType["default"].POSTRENDER, _this.drawLabels_.bind(_this));
    }
    /**
     * @type {Array<number>}
     * @private
     */


    _this.intervals_ = options.intervals !== undefined ? options.intervals : INTERVALS; // use a source with a custom loader for lines & text

    _this.setSource(new _Vector2["default"]({
      loader: _this.loaderFunction.bind(_this),
      strategy: _this.strategyFunction.bind(_this),
      features: new _Collection["default"](),
      overlaps: false,
      useSpatialIndex: false,
      wrapX: options.wrapX
    }));
    /**
     * feature pool to use when updating graticule
     * @type {Array<Feature>}
     * @private
     */


    _this.featurePool_ = [];
    /**
     * @type {Style}
     * @private
     */

    _this.lineStyle_ = new _Style["default"]({
      stroke: _this.strokeStyle_
    });
    /**
     * @type {?import("../extent.js").Extent}
     * @private
     */

    _this.loadedExtent_ = null;
    /**
     * @type {?import("../extent.js").Extent}
     * @private
     */

    _this.renderedExtent_ = null;
    /**
     * @type {?number}
     * @private
     */

    _this.renderedResolution_ = null;

    _this.setRenderOrder(null);

    return _this;
  }
  /**
   * Strategy function for loading features based on the view's extent and
   * resolution.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @return {Array<import("../extent.js").Extent>} Extents.
   */


  Graticule.prototype.strategyFunction = function (extent, resolution) {
    // extents may be passed in different worlds, to avoid endless loop we use only one
    var realWorldExtent = extent.slice();

    if (this.projection_ && this.getSource().getWrapX()) {
      (0, _extent.wrapX)(realWorldExtent, this.projection_);
    }

    if (this.loadedExtent_) {
      if ((0, _extent.approximatelyEquals)(this.loadedExtent_, realWorldExtent, resolution)) {
        // make sure result is exactly equal to previous extent
        realWorldExtent = this.loadedExtent_.slice();
      } else {
        // we should not keep track of loaded extents
        this.getSource().removeLoadedExtent(this.loadedExtent_);
      }
    }

    return [realWorldExtent];
  };
  /**
   * Update geometries in the source based on current view
   * @param {import("../extent").Extent} extent Extent
   * @param {number} resolution Resolution
   * @param {import("../proj/Projection.js").default} projection Projection
   */


  Graticule.prototype.loaderFunction = function (extent, resolution, projection) {
    this.loadedExtent_ = extent;
    var source = this.getSource(); // only consider the intersection between our own extent & the requested one

    var layerExtent = this.getExtent() || [-Infinity, -Infinity, Infinity, Infinity];
    var renderExtent = (0, _extent.getIntersection)(layerExtent, extent);

    if (this.renderedExtent_ && (0, _extent.equals)(this.renderedExtent_, renderExtent) && this.renderedResolution_ === resolution) {
      return;
    }

    this.renderedExtent_ = renderExtent;
    this.renderedResolution_ = resolution; // bail out if nothing to render

    if ((0, _extent.isEmpty)(renderExtent)) {
      return;
    } // update projection info


    var center = (0, _extent.getCenter)(renderExtent);
    var squaredTolerance = resolution * resolution / 4;
    var updateProjectionInfo = !this.projection_ || !(0, _proj.equivalent)(this.projection_, projection);

    if (updateProjectionInfo) {
      this.updateProjectionInfo_(projection);
    }

    this.createGraticule_(renderExtent, center, resolution, squaredTolerance); // first make sure we have enough features in the pool

    var featureCount = this.meridians_.length + this.parallels_.length;

    if (this.meridiansLabels_) {
      featureCount += this.meridians_.length;
    }

    if (this.parallelsLabels_) {
      featureCount += this.parallels_.length;
    }

    var feature;

    while (featureCount > this.featurePool_.length) {
      feature = new _Feature["default"]();
      this.featurePool_.push(feature);
    }

    var featuresColl = source.getFeaturesCollection();
    featuresColl.clear();
    var poolIndex = 0; // add features for the lines & labels

    var i, l;

    for (i = 0, l = this.meridians_.length; i < l; ++i) {
      feature = this.featurePool_[poolIndex++];
      feature.setGeometry(this.meridians_[i]);
      feature.setStyle(this.lineStyle_);
      featuresColl.push(feature);
    }

    for (i = 0, l = this.parallels_.length; i < l; ++i) {
      feature = this.featurePool_[poolIndex++];
      feature.setGeometry(this.parallels_[i]);
      feature.setStyle(this.lineStyle_);
      featuresColl.push(feature);
    }
  };
  /**
   * @param {number} lon Longitude.
   * @param {number} minLat Minimal latitude.
   * @param {number} maxLat Maximal latitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {number} Index.
   * @private
   */


  Graticule.prototype.addMeridian_ = function (lon, minLat, maxLat, squaredTolerance, extent, index) {
    var lineString = this.getMeridian_(lon, minLat, maxLat, squaredTolerance, index);

    if ((0, _extent.intersects)(lineString.getExtent(), extent)) {
      if (this.meridiansLabels_) {
        var text = this.lonLabelFormatter_(lon);

        if (index in this.meridiansLabels_) {
          this.meridiansLabels_[index].text = text;
        } else {
          this.meridiansLabels_[index] = {
            geom: new _Point["default"]([]),
            text: text
          };
        }
      }

      this.meridians_[index++] = lineString;
    }

    return index;
  };
  /**
   * @param {number} lat Latitude.
   * @param {number} minLon Minimal longitude.
   * @param {number} maxLon Maximal longitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {number} Index.
   * @private
   */


  Graticule.prototype.addParallel_ = function (lat, minLon, maxLon, squaredTolerance, extent, index) {
    var lineString = this.getParallel_(lat, minLon, maxLon, squaredTolerance, index);

    if ((0, _extent.intersects)(lineString.getExtent(), extent)) {
      if (this.parallelsLabels_) {
        var text = this.latLabelFormatter_(lat);

        if (index in this.parallelsLabels_) {
          this.parallelsLabels_[index].text = text;
        } else {
          this.parallelsLabels_[index] = {
            geom: new _Point["default"]([]),
            text: text
          };
        }
      }

      this.parallels_[index++] = lineString;
    }

    return index;
  };
  /**
   * @param {import("../render/Event.js").default} event Render event.
   * @private
   */


  Graticule.prototype.drawLabels_ = function (event) {
    var rotation = event.frameState.viewState.rotation;
    var resolution = event.frameState.viewState.resolution;
    var size = event.frameState.size;
    var extent = event.frameState.extent;
    var rotationCenter = (0, _extent.getCenter)(extent);
    var rotationExtent = extent;

    if (rotation) {
      var unrotatedWidth = size[0] * resolution;
      var unrotatedHeight = size[1] * resolution;
      rotationExtent = [rotationCenter[0] - unrotatedWidth / 2, rotationCenter[1] - unrotatedHeight / 2, rotationCenter[0] + unrotatedWidth / 2, rotationCenter[1] + unrotatedHeight / 2];
    }

    var startWorld = 0;
    var endWorld = 0;
    var labelsAtStart = this.latLabelPosition_ < 0.5;
    var projectionExtent = this.projection_.getExtent();
    var worldWidth = (0, _extent.getWidth)(projectionExtent);

    if (this.getSource().getWrapX() && this.projection_.canWrapX() && !(0, _extent.containsExtent)(projectionExtent, extent)) {
      startWorld = Math.floor((extent[0] - projectionExtent[0]) / worldWidth);
      endWorld = Math.ceil((extent[2] - projectionExtent[2]) / worldWidth);
      var inverted = Math.abs(rotation) > Math.PI / 2;
      labelsAtStart = labelsAtStart !== inverted;
    }

    var vectorContext = (0, _render.getVectorContext)(event);

    for (var world = startWorld; world <= endWorld; ++world) {
      var poolIndex = this.meridians_.length + this.parallels_.length;
      var feature = void 0,
          index = void 0,
          l = void 0,
          textPoint = void 0;

      if (this.meridiansLabels_) {
        for (index = 0, l = this.meridiansLabels_.length; index < l; ++index) {
          var lineString = this.meridians_[index];

          if (!rotation && world === 0) {
            textPoint = this.getMeridianPoint_(lineString, extent, index);
          } else {
            var clone = lineString.clone();
            clone.translate(world * worldWidth, 0);
            clone.rotate(-rotation, rotationCenter);
            textPoint = this.getMeridianPoint_(clone, rotationExtent, index);
            textPoint.rotate(rotation, rotationCenter);
          }

          feature = this.featurePool_[poolIndex++];
          feature.setGeometry(textPoint);
          feature.set('graticule_label', this.meridiansLabels_[index].text);
          vectorContext.drawFeature(feature, this.lonLabelStyle_(feature));
        }
      }

      if (this.parallelsLabels_) {
        if (world === startWorld && labelsAtStart || world === endWorld && !labelsAtStart) {
          for (index = 0, l = this.parallels_.length; index < l; ++index) {
            var lineString = this.parallels_[index];

            if (!rotation && world === 0) {
              textPoint = this.getParallelPoint_(lineString, extent, index);
            } else {
              var clone = lineString.clone();
              clone.translate(world * worldWidth, 0);
              clone.rotate(-rotation, rotationCenter);
              textPoint = this.getParallelPoint_(clone, rotationExtent, index);
              textPoint.rotate(rotation, rotationCenter);
            }

            feature = this.featurePool_[poolIndex++];
            feature.setGeometry(textPoint);
            feature.set('graticule_label', this.parallelsLabels_[index].text);
            vectorContext.drawFeature(feature, this.latLabelStyle_(feature));
          }
        }
      }
    }
  };
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} squaredTolerance Squared tolerance.
   * @private
   */


  Graticule.prototype.createGraticule_ = function (extent, center, resolution, squaredTolerance) {
    var interval = this.getInterval_(resolution);

    if (interval == -1) {
      this.meridians_.length = 0;
      this.parallels_.length = 0;

      if (this.meridiansLabels_) {
        this.meridiansLabels_.length = 0;
      }

      if (this.parallelsLabels_) {
        this.parallelsLabels_.length = 0;
      }

      return;
    }

    var wrapX = false;
    var projectionExtent = this.projection_.getExtent();
    var worldWidth = (0, _extent.getWidth)(projectionExtent);

    if (this.getSource().getWrapX() && this.projection_.canWrapX() && !(0, _extent.containsExtent)(projectionExtent, extent)) {
      if ((0, _extent.getWidth)(extent) >= worldWidth) {
        extent[0] = projectionExtent[0];
        extent[2] = projectionExtent[2];
      } else {
        wrapX = true;
      }
    } // Constrain the center to fit into the extent available to the graticule


    var validCenterP = [(0, _math.clamp)(center[0], this.minX_, this.maxX_), (0, _math.clamp)(center[1], this.minY_, this.maxY_)]; // Transform the center to lon lat
    // Some projections may have a void area at the poles
    // so replace any NaN latitudes with the min or max value closest to a pole

    var centerLonLat = this.toLonLatTransform_(validCenterP);

    if (isNaN(centerLonLat[1])) {
      centerLonLat[1] = Math.abs(this.maxLat_) >= Math.abs(this.minLat_) ? this.maxLat_ : this.minLat_;
    }

    var centerLon = (0, _math.clamp)(centerLonLat[0], this.minLon_, this.maxLon_);
    var centerLat = (0, _math.clamp)(centerLonLat[1], this.minLat_, this.maxLat_);
    var maxLines = this.maxLines_;
    var cnt, idx, lat, lon; // Limit the extent to fit into the extent available to the graticule

    var validExtentP = extent;

    if (!wrapX) {
      validExtentP = [(0, _math.clamp)(extent[0], this.minX_, this.maxX_), (0, _math.clamp)(extent[1], this.minY_, this.maxY_), (0, _math.clamp)(extent[2], this.minX_, this.maxX_), (0, _math.clamp)(extent[3], this.minY_, this.maxY_)];
    } // Transform the extent to get the lon lat ranges for the edges of the extent


    var validExtent = (0, _extent.applyTransform)(validExtentP, this.toLonLatTransform_, undefined, 8);
    var maxLat = validExtent[3];
    var maxLon = validExtent[2];
    var minLat = validExtent[1];
    var minLon = validExtent[0];

    if (!wrapX) {
      // Check if extremities of the world extent lie inside the extent
      // (for example the pole in a polar projection)
      // and extend the extent as appropriate
      if ((0, _extent.containsCoordinate)(validExtentP, this.bottomLeft_)) {
        minLon = this.minLon_;
        minLat = this.minLat_;
      }

      if ((0, _extent.containsCoordinate)(validExtentP, this.bottomRight_)) {
        maxLon = this.maxLon_;
        minLat = this.minLat_;
      }

      if ((0, _extent.containsCoordinate)(validExtentP, this.topLeft_)) {
        minLon = this.minLon_;
        maxLat = this.maxLat_;
      }

      if ((0, _extent.containsCoordinate)(validExtentP, this.topRight_)) {
        maxLon = this.maxLon_;
        maxLat = this.maxLat_;
      } // The transformed center may also extend the lon lat ranges used for rendering


      maxLat = (0, _math.clamp)(maxLat, centerLat, this.maxLat_);
      maxLon = (0, _math.clamp)(maxLon, centerLon, this.maxLon_);
      minLat = (0, _math.clamp)(minLat, this.minLat_, centerLat);
      minLon = (0, _math.clamp)(minLon, this.minLon_, centerLon);
    } // Create meridians


    centerLon = Math.floor(centerLon / interval) * interval;
    lon = (0, _math.clamp)(centerLon, this.minLon_, this.maxLon_);
    idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, 0);
    cnt = 0;

    if (wrapX) {
      while ((lon -= interval) >= minLon && cnt++ < maxLines) {
        idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
      }
    } else {
      while (lon != this.minLon_ && cnt++ < maxLines) {
        lon = Math.max(lon - interval, this.minLon_);
        idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
      }
    }

    lon = (0, _math.clamp)(centerLon, this.minLon_, this.maxLon_);
    cnt = 0;

    if (wrapX) {
      while ((lon += interval) <= maxLon && cnt++ < maxLines) {
        idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
      }
    } else {
      while (lon != this.maxLon_ && cnt++ < maxLines) {
        lon = Math.min(lon + interval, this.maxLon_);
        idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
      }
    }

    this.meridians_.length = idx;

    if (this.meridiansLabels_) {
      this.meridiansLabels_.length = idx;
    } // Create parallels


    centerLat = Math.floor(centerLat / interval) * interval;
    lat = (0, _math.clamp)(centerLat, this.minLat_, this.maxLat_);
    idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, 0);
    cnt = 0;

    while (lat != this.minLat_ && cnt++ < maxLines) {
      lat = Math.max(lat - interval, this.minLat_);
      idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
    }

    lat = (0, _math.clamp)(centerLat, this.minLat_, this.maxLat_);
    cnt = 0;

    while (lat != this.maxLat_ && cnt++ < maxLines) {
      lat = Math.min(lat + interval, this.maxLat_);
      idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
    }

    this.parallels_.length = idx;

    if (this.parallelsLabels_) {
      this.parallelsLabels_.length = idx;
    }
  };
  /**
   * @param {number} resolution Resolution.
   * @return {number} The interval in degrees.
   * @private
   */


  Graticule.prototype.getInterval_ = function (resolution) {
    var centerLon = this.projectionCenterLonLat_[0];
    var centerLat = this.projectionCenterLonLat_[1];
    var interval = -1;
    var target = Math.pow(this.targetSize_ * resolution, 2);
    /** @type {Array<number>} **/

    var p1 = [];
    /** @type {Array<number>} **/

    var p2 = [];

    for (var i = 0, ii = this.intervals_.length; i < ii; ++i) {
      var delta = (0, _math.clamp)(this.intervals_[i] / 2, 0, 90); // Don't attempt to transform latitudes beyond the poles!

      var clampedLat = (0, _math.clamp)(centerLat, -90 + delta, 90 - delta);
      p1[0] = centerLon - delta;
      p1[1] = clampedLat - delta;
      p2[0] = centerLon + delta;
      p2[1] = clampedLat + delta;
      this.fromLonLatTransform_(p1, p1);
      this.fromLonLatTransform_(p2, p2);
      var dist = Math.pow(p2[0] - p1[0], 2) + Math.pow(p2[1] - p1[1], 2);

      if (dist <= target) {
        break;
      }

      interval = this.intervals_[i];
    }

    return interval;
  };
  /**
   * @param {number} lon Longitude.
   * @param {number} minLat Minimal latitude.
   * @param {number} maxLat Maximal latitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} The meridian line string.
   * @param {number} index Index.
   * @private
   */


  Graticule.prototype.getMeridian_ = function (lon, minLat, maxLat, squaredTolerance, index) {
    var flatCoordinates = (0, _geodesic.meridian)(lon, minLat, maxLat, this.projection_, squaredTolerance);
    var lineString = this.meridians_[index];

    if (!lineString) {
      lineString = new _LineString["default"](flatCoordinates, _GeometryLayout["default"].XY);
      this.meridians_[index] = lineString;
    } else {
      lineString.setFlatCoordinates(_GeometryLayout["default"].XY, flatCoordinates);
      lineString.changed();
    }

    return lineString;
  };
  /**
   * @param {LineString} lineString Meridian
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {Point} Meridian point.
   * @private
   */


  Graticule.prototype.getMeridianPoint_ = function (lineString, extent, index) {
    var flatCoordinates = lineString.getFlatCoordinates();
    var bottom = 1;
    var top = flatCoordinates.length - 1;

    if (flatCoordinates[bottom] > flatCoordinates[top]) {
      bottom = top;
      top = 1;
    }

    var clampedBottom = Math.max(extent[1], flatCoordinates[bottom]);
    var clampedTop = Math.min(extent[3], flatCoordinates[top]);
    var lat = (0, _math.clamp)(extent[1] + Math.abs(extent[1] - extent[3]) * this.lonLabelPosition_, clampedBottom, clampedTop);
    var coordinate0 = flatCoordinates[bottom - 1] + (flatCoordinates[top - 1] - flatCoordinates[bottom - 1]) * (lat - flatCoordinates[bottom]) / (flatCoordinates[top] - flatCoordinates[bottom]);
    var coordinate = [coordinate0, lat];
    var point = this.meridiansLabels_[index].geom;
    point.setCoordinates(coordinate);
    return point;
  };
  /**
   * Get the list of meridians.  Meridians are lines of equal longitude.
   * @return {Array<LineString>} The meridians.
   * @api
   */


  Graticule.prototype.getMeridians = function () {
    return this.meridians_;
  };
  /**
   * @param {number} lat Latitude.
   * @param {number} minLon Minimal longitude.
   * @param {number} maxLon Maximal longitude.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} The parallel line string.
   * @param {number} index Index.
   * @private
   */


  Graticule.prototype.getParallel_ = function (lat, minLon, maxLon, squaredTolerance, index) {
    var flatCoordinates = (0, _geodesic.parallel)(lat, minLon, maxLon, this.projection_, squaredTolerance);
    var lineString = this.parallels_[index];

    if (!lineString) {
      lineString = new _LineString["default"](flatCoordinates, _GeometryLayout["default"].XY);
    } else {
      lineString.setFlatCoordinates(_GeometryLayout["default"].XY, flatCoordinates);
      lineString.changed();
    }

    return lineString;
  };
  /**
   * @param {LineString} lineString Parallels.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} index Index.
   * @return {Point} Parallel point.
   * @private
   */


  Graticule.prototype.getParallelPoint_ = function (lineString, extent, index) {
    var flatCoordinates = lineString.getFlatCoordinates();
    var left = 0;
    var right = flatCoordinates.length - 2;

    if (flatCoordinates[left] > flatCoordinates[right]) {
      left = right;
      right = 0;
    }

    var clampedLeft = Math.max(extent[0], flatCoordinates[left]);
    var clampedRight = Math.min(extent[2], flatCoordinates[right]);
    var lon = (0, _math.clamp)(extent[0] + Math.abs(extent[0] - extent[2]) * this.latLabelPosition_, clampedLeft, clampedRight);
    var coordinate1 = flatCoordinates[left + 1] + (flatCoordinates[right + 1] - flatCoordinates[left + 1]) * (lon - flatCoordinates[left]) / (flatCoordinates[right] - flatCoordinates[left]);
    var coordinate = [lon, coordinate1];
    var point = this.parallelsLabels_[index].geom;
    point.setCoordinates(coordinate);
    return point;
  };
  /**
   * Get the list of parallels.  Parallels are lines of equal latitude.
   * @return {Array<LineString>} The parallels.
   * @api
   */


  Graticule.prototype.getParallels = function () {
    return this.parallels_;
  };
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @private
   */


  Graticule.prototype.updateProjectionInfo_ = function (projection) {
    var epsg4326Projection = (0, _proj.get)('EPSG:4326');
    var worldExtent = projection.getWorldExtent();
    this.maxLat_ = worldExtent[3];
    this.maxLon_ = worldExtent[2];
    this.minLat_ = worldExtent[1];
    this.minLon_ = worldExtent[0]; // If the world extent crosses the dateline define a custom transform to
    // return longitudes which wrap the dateline

    var toLonLatTransform = (0, _proj.getTransform)(projection, epsg4326Projection);

    if (this.minLon_ < this.maxLon_) {
      this.toLonLatTransform_ = toLonLatTransform;
    } else {
      var split_1 = this.minLon_ + this.maxLon_ / 2;
      this.maxLon_ += 360;

      this.toLonLatTransform_ = function (coordinates, opt_output, opt_dimension) {
        var dimension = opt_dimension || 2;
        var lonLatCoordinates = toLonLatTransform(coordinates, opt_output, dimension);

        for (var i = 0, l = lonLatCoordinates.length; i < l; i += dimension) {
          if (lonLatCoordinates[i] < split_1) {
            lonLatCoordinates[i] += 360;
          }
        }

        return lonLatCoordinates;
      };
    } // Transform the extent to get the limits of the view projection extent
    // which should be available to the graticule


    this.fromLonLatTransform_ = (0, _proj.getTransform)(epsg4326Projection, projection);
    var worldExtentP = (0, _extent.applyTransform)([this.minLon_, this.minLat_, this.maxLon_, this.maxLat_], this.fromLonLatTransform_, undefined, 8);
    this.minX_ = worldExtentP[0];
    this.maxX_ = worldExtentP[2];
    this.minY_ = worldExtentP[1];
    this.maxY_ = worldExtentP[3]; // Determine the view projection coordinates of the extremities of the world extent
    // as these may lie inside a view extent (for example the pole in a polar projection)

    this.bottomLeft_ = this.fromLonLatTransform_([this.minLon_, this.minLat_]);
    this.bottomRight_ = this.fromLonLatTransform_([this.maxLon_, this.minLat_]);
    this.topLeft_ = this.fromLonLatTransform_([this.minLon_, this.maxLat_]);
    this.topRight_ = this.fromLonLatTransform_([this.maxLon_, this.maxLat_]); // Transform the projection center to lon lat
    // Some projections may have a void area at the poles
    // so replace any NaN latitudes with the min or max value closest to a pole

    this.projectionCenterLonLat_ = this.toLonLatTransform_((0, _extent.getCenter)(projection.getExtent()));

    if (isNaN(this.projectionCenterLonLat_[1])) {
      this.projectionCenterLonLat_[1] = Math.abs(this.maxLat_) >= Math.abs(this.minLat_) ? this.maxLat_ : this.minLat_;
    }

    this.projection_ = projection;
  };

  return Graticule;
}(_Vector["default"]);

var _default = Graticule;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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